
	<div id="page-wrapper" [class.open]="isSidebarToggled">
	  <div id="sidebar-wrapper" >
		<ul *ngIf="!showMenu()" class="sidebar">
		  <li class="sidebar-main">
			<a (click)="toggleSidebar()" style="cursor: pointer;">
				Identity App
				<span class="menu-icon glyphicon glyphicon-transfer"></span>
			  </a>
		  </li>
		</ul>
		<ul *ngIf="showMenu()" class="sidebar">
		  <li class="sidebar-main">
			<a (click)="toggleSidebar()" style="cursor: pointer;">
			Identity App
				<span class="menu-icon glyphicon glyphicon-transfer"></span>
			  </a>
		  </li>
		  <li class="sidebar-title"><span>NAVIGATION</span></li>
			<li class="sidebar-list">
					<a [routerLink]="['/idp/' + acctNumber + '/idps']" routerLinkActive="active">Identity Providers <span *ngIf="isSidebarToggled == null ? false : !isSidebarToggled" class="menu-icon glyphicon glyphicon-th-list" title="Identity Providers"></span></a>
			</li>
			<li class="sidebar-list">
					<a [routerLink]="['/idp/' + acctNumber + '/idp-users']" routerLinkActive="active">IdP Users <span *ngIf="isSidebarToggled == null ? false : !isSidebarToggled" class="menu-icon glyphicon glyphicon-user" title="Users"></span></a>
			</li>
			<li class="sidebar-list">
					<a [routerLink]="['/idp/' + acctNumber + '/roles-mapping/']" routerLinkActive="active">Roles Mapping <span *ngIf="isSidebarToggled == null ? false : !isSidebarToggled" class="menu-icon glyphicon glyphicon-bookmark" title="Roles Mapping"></span></a>
			</li>
			<li class="sidebar-list">
					<a [routerLink]="['/idp/' + acctNumber + '/domain-verification/']" routerLinkActive="active">Domain Verification <span *ngIf="isSidebarToggled == null ? false : !isSidebarToggled" class="menu-icon glyphicon glyphicon-ok-circle" title="Domain Verification"></span></a>
			</li>
			<li class="sidebar-list">
					<a [routerLink]="['/idp/' + acctNumber + '/users']" routerLinkActive="active">Users <span *ngIf="isSidebarToggled == null ? false : !isSidebarToggled" class="menu-icon glyphicon glyphicon-user" title="Users"></span></a>
			</li>
			<li class="sidebar-list">
				<a target="_blank" href="https://vm.success.centegix.com/article/190-identity-app">Support <span *ngIf="isSidebarToggled == null ? false : !isSidebarToggled" class="menu-icon glyphicon glyphicon-question-sign" title="Support"></span></a>
			</li>
		</ul>
		<div class="sidebar-footer">
		  <div class="col-xs-8">
			<a href="https://centegix.com" target="_blank" [title]="appVersionTitle">
			   &copy; {{today | date:'y'}} centegix.com
			  </a>
		  </div>
		</div>
	  </div>
	  <div id="content-wrapper">
		<div class="page-content">
		  <div class="row header">
			<div class="col-xs-12">
			  <div class="user pull-right" style="min-width:0px;padding:11px 15px 15px 15px;">
			  <a *ngIf="!hasRoles" style="cursor:pointer; color:#919191; vertical-align: middle;" (click)="logout()">Logout</a>
				<div class="dropdown" [class.open]="isUserToggled" style="text-align:right;">
				  <a style="cursor:pointer; color:#919191;" class="dropdown-toggle" data-toggle="dropdown" (click)="toggleUser()" [offClick]="clickedOutside">
						{{userGreeting}}
				    </a>
				  <ul class="dropdown-menu dropdown-menu-right" role="menu">
						<li class="link">
							<a [href]="accLink">
								Account
							</a>
						</li>
						<li class="divider"></li>
						<li class="link">
							<a (click)="logout()">
							    Logout
							</a>
						</li>
				  </ul>
				</div>
				<div *ngIf="showMenu()"><a style="color:##696969" [routerLink]="['/identity-access']">{{schoolsName}}</a></div>
			  </div>
			  <div class="meta">
				<div class="page">
				  {{dashboardTitle}}
				</div>
				<div class="breadcrumb-links">
					<span *ngFor="let b of breadcrumbs">/ <a *ngIf="!b.noLink" href="{{b.link}}">{{b.title}}</a> <span *ngIf="b.noLink">{{b.title}}</span> </span>
				</div>
			  </div>
			</div>
		  </div>
			<app-reload [maxIdle]="appReloadMaxIdle" [forceTimeout]="appReloadForceTimeout" (onChange)="appReload($event)"></app-reload>
			<div *ngIf="msg.msg" class="row">
				<div class="col-lg-5 col-md-7 col-xs-12">
					<alert [alert]="msg"></alert>
				</div>
			</div>
		  <router-outlet (activate)="changeRoute()"></router-outlet>
		  <identity-footer></identity-footer>
		</div>
	  </div>
	</div>
  